
import { defineComponent } from "vue";
import { polishTranslate } from "@book-searcher/data";
import type { HTMLInputEvent } from "../../types";
export default defineComponent({
  name: "Checkbox",
  props: {
    text: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Object as () => string[],
    },
    checked: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
  },

  setup(prp, ctx) {
    const handleChangeCheckbox = (e: HTMLInputEvent) => {
      if (prp.modelValue) {
        if (e.target.checked) {
          return ctx.emit("update:modelValue", [
            ...prp.modelValue,
            e.target.value,
          ]);
        }
        return ctx.emit(
          "update:modelValue",
          prp.modelValue.filter((item) => item !== e.target.value),
        );
      }
    };
    return { polishTranslate, handleChangeCheckbox };
  },
});
